import "./heading.css";
import { ButtonGeneric } from "../../ButtonGeneric/buttonGeneric";
import IconAtributo from "../../../assets/svgs/atributo.svg";
import PlusButtonFilter from "../../../assets/svgs/plusButtonFilter.svg";
import IconPlus from "../../../assets/svgs/plus.svg";
import IconBack from "../../../assets/img/sair_det.png";
import IconComment from "../../../assets/img/comment.png";
import IconDown from "../../../assets/img/icon_pdf.svg";
import IconReport from "../../../assets/svgs/pdfBlue.svg";
import IconEdit from "../../../assets/img/editar.png";
import IconAlert from "../../../assets/img/alert.png";
import IconArqu from "../../../assets/img/arquivos.png";
import IconD from "../../../assets/img/upload_img.png";
import IconParams from "../../../assets/img/icon_params.png";
import iconabort from "../../../assets/svgs/abort.svg";
import IconImg from "../../..//assets/img/icon_img.png";
import Icondownload from "../../../assets/svgs/download.svg";
import ClockButtonFilter from "../../../assets/svgs/clockButtonFilter.svg";
import IconHouse from "../../../assets/svgs/House.svg";
import BallsColor from "../ballsColor/ballsColor";
import { useNavigate } from "react-router-dom";
import NotificationIcon from "../../../assets/svgs/NotificationIcon.svg";
import axios from "axios";
import axiosInstance from "../../../api/axiosInstance";
import UserService from "../../../utils/UserService";
import { useState, useEffect } from "react";
import Modal from "../../modal/modal";
import InfoAlert from "../../alertComponent/alertUpdated";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import Filters from "../filters/filters";
import Continuos from "../../../assets/svgs/continuos.svg";
import { clearPnCode, clearSession } from "../../../redux/slices/sessionSlice";
import CheckButtonFilter from "../../../assets/svgs/checkButtonFilter.svg";
import SuspensoButtonFilter from "../../../assets/svgs/suspenso.svg";
import comentar from "../../../assets/svgs/comentar.svg";
import approver from "../../../assets/svgs/aprovar.svg";
import reloadButtonFilter from "../../../assets/svgs/reloadButtonFilter.svg";
import transferIcon from "../../../assets/svgs/out.svg";
import notificationIcon from "../../../assets/svgs/notification.svg";
import close from "../../../assets/img/close_white.svg";
import { BaseHeading } from "../../../types/baseHeading";
import { CircularProgress, Tooltip } from "@mui/material";
import DescriptionCell from "../Requests/columns/descriptionCell";
import ModalLog from "../modalLog/modalLog";
import { default as MuiModal } from "@mui/material/Modal";
import Notification from "../../fluxo-tax/Notification/notification";
import functionDate from "../../../utils/formatarData";
import {
  isStatusAllow,
  isStatusAllowNaladi,
} from "../../../utils/statusClassications/statusClassification";
import { useRoles } from "../../../hooks/roles";

const EXPLAINABILITY_REPORT_BASE_URL =
  process.env.REACT_APP_AI_ASSISTANT_URL;
const EXPLAINABILITY_REPORT_ENDPOINT = `${EXPLAINABILITY_REPORT_BASE_URL}/ncm_explainability_report`;

const isDevEnvironment = () =>
  process.env.REACT_APP_KEYCLOAK_REALM === "dev" ||
  process.env.REACT_APP_KEYCLOAK_CLIENT === "ncm-client-dev" ||
  process.env.REACT_APP_KEYCLOAK_CLIENT === "dev";
export interface HeadingOne extends BaseHeading {
  materialData?: {
    sessionId: string;
    productCode: string;
    productSimilarCode: string | null;
    center: string | null;
    classificationStatus: string;
    classificationID: string;
    ncmCode: string;
    emitter?: string | null;
  };
}

export const Heading = ({
  getSessionId,
  titlePage,
  buttonEmissao,
  buttonVoltar,
  filtros,
  statusProps,
  detalsIA,
  buttonDowload,
  text1,
  text2,
  text3,
  blockText,
  buttonAppover,
  setMaterialPartNumber,
  materialPartNumber,
  setMaterialPartDesc,
  materialPartDesc,
  emitentePartNumber,
  setEmitentePartDesc,
  centerFilter,
  setCenterFilter,
  setStartDate,
  startDate,
  endDate,
  setEndDate,
  classificationQuizStartDate,
  setClassificationQuizStartDate,
  classificationQuizFinishDate,
  setClassificationQuizFinishDate,
  classificationApprovalStartDate,
  setClassificationApprovalStartDate,
  classificationApprovalEndDate,
  setClassificationApprovalEndDate,
  selectedOptionsStatus,
  setSelectedOptionsStatus,
  selectedOptionsCenter,
  setSelectedOptionsCenter,
  selectedOptionsFlag,
  setSelectedOptionsFlag,
  selectedOptionsHarmon,
  setSelectedOptionsHarmon,
  materialData,
  isTax,
  onTarget,
  productCode,
  isBanner,
  isRead,
  openModalComentar,
  openModalAprover,
  openModalCorrigir,
  openModalNaladi,
  openModalResetar,
  openModalTransferir,
  handleFilter,
  setPage,
  setPageSize,
  setFilter,
  simpleHeading,
}: HeadingOne) => {
  const navigate = useNavigate();
  const [, setIsSimilar] = useState(false);
  const [, setDescription] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataCreate, setDataCreate] = useState("");
  const [showDownloads] = useState(false);
  const [isHarmon, setIsHarmon] = useState(false);
  const [isReason, setIsReason] = useState("");
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [isExplainabilityLoading, setIsExplainabilityLoading] = useState(false);
  const [showExplainabilityError, setShowExplainabilityError] = useState(false);

  const [modalStates, setModalStates] = useState({
    isLoad: false,
    isOpen: false,
    isOpenPDF: false,
    isOpenExcel: false,
    pdfDownloaded: false,
    excelDownloaded: false,
    isComment: false,
    isArchive: false,
  });
  const dispatch = useDispatch();

  const { basicUserInfo } = useSelector((state: RootState) => state.user);

  const { sessionVerify } = useSelector(
    (state: RootState) => state.sessionInfo,
  );
  const { httpStatus } = useSelector(
    (state: RootState) => state.sessionMessage,
  );

  const { sessionMaterial } = useSelector(
    (state: RootState) => state.sessionClassifications,
  );

  const sessionMetadataImgs = sessionMaterial?.files ?? null;
  const classificationStatuH = sessionMaterial?.classificationStatus?.name;
  let activePermission: "isTax" | "isEngineer" | null = null;

  const { isEngineer, isTax: isTaxRole } = useRoles();
  const canShowPendingGroup = isTax ?? isTaxRole;

  const has_crea = basicUserInfo?.has_crea === false;

  if (isTax && !isEngineer) {
    activePermission = "isTax";
  } else if (isEngineer && !isTax) {
    activePermission = "isEngineer";
  } else if (isEngineer && isTax) {
    activePermission = "isTax";
  }

  const isCurrentUserEmitter = (emitter: string | null) => {
    return basicUserInfo?.email === emitter;
  };

  const disabledButtonsForEmitter = (emitter: string | null) => {
    if (!isCurrentUserEmitter(emitter) && activePermission === "isEngineer") {
      return true;
    }
    return false;
  };

  const hasClassificationOutput =
    sessionMaterial?.sessionMetadata?.outputFile != null;
  const canDownloadPdf =
    activePermission &&
    (isStatusAllow({ status: classificationStatuH, role: activePermission }) ||
      (classificationStatuH === "PENDENTE_GRUPO" &&
        hasClassificationOutput));
  const canDownloadExplainabilityReport =
    canDownloadPdf;

  const backButton = () => {
    dispatch(clearSession());
    navigate("/");
  };

  const handleNavigation = () => {
    dispatch(clearPnCode(null));
    navigate("/emissao-laudo");
  };

  const toggleModal = (modal: keyof typeof modalStates) => {
    setModalStates((prevState) => ({
      ...prevState,
      [modal]: !prevState[modal],
    }));
  };
  const handleCloseModal = (
    modal: keyof typeof modalStates,
    downloadState: "pdfDownloaded" | "excelDownloaded",
  ) => {
    setModalStates((prevState) => ({
      ...prevState,
      [modal]: false,
      [downloadState]: true,
    }));
  };

  useEffect(() => {
    if (sessionVerify) {
      setIsSimilar(sessionVerify?.isSimilar);
    }
  }, [sessionVerify]);

  const downloadFile = async (
    fileType: "excel" | "pdf",
    sessionId: string,
    forceDownload?: boolean,
  ) => {
    const token = UserService.getToken();
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob" as const,
    };

    const apiEndpoint =
      fileType === "excel"
        ? `/downloads/excel/${sessionId}`
        : `/downloads/pdf/${sessionId}?download=${forceDownload}`;

    try {
      const response = await axiosInstance.get(apiEndpoint, config);

      const contentDisposition =
        response.headers["Content-Disposition"] ||
        response.request?.getResponseHeader?.("Content-Disposition");

      let fileName =
        fileType === "excel" ? "classification.xlsx" : "classification.pdf";

      if (contentDisposition && contentDisposition.includes("filename=")) {
        fileName = contentDisposition
          .split("filename=")[1]
          .replaceAll('"', "")
          .trim();
      }

      if (fileType === "excel") {
        await download(fileName, response.data);
        toggleModal("isOpenExcel");
        return;
      }

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      if (forceDownload) {
        await download(fileName, pdfBlob);
        toggleModal("isOpenPDF");
      } else {
        setPdfUrl(pdfUrl);
        setIsViewerOpen(true);
      }
    } catch (error) {
      console.error(
        `Erro ao baixar o arquivo ${fileType.toUpperCase()}:`,
        error,
      );
    }
  };

  const download = async (filename: string, data: Blob) => {
    const downloadUrl = window.URL.createObjectURL(data);
    const element = document.createElement("a");
    element.href = downloadUrl;
    element.setAttribute("download", filename);
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    window.URL.revokeObjectURL(downloadUrl);
  };

  const openExplainabilityReport = async (sessionId?: string) => {
    if (!sessionId) {
      return;
    }

    setIsExplainabilityLoading(true);

    try {
      const { data } = await axios.post(EXPLAINABILITY_REPORT_ENDPOINT, {
        sessionId,
      });

      if (data?.reportUrl) {
        window.open(data.reportUrl, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.error("Erro ao abrir o relatório explicativo:", error);
      setShowExplainabilityError(true);
      setTimeout(() => setShowExplainabilityError(false), 5000);
    } finally {
      setIsExplainabilityLoading(false);
    }
  };

  const storedValue = localStorage.getItem("selectedEmiiter");
  const emitter = materialData?.emitter || storedValue || null;

  const statusMap: Record<
    string,
    {
      buttons: {
        title: string;
        color: string;
        onAction?: () => void;
        onClick?: () => void;
        img?: string;
        status?: string;
        disabled?: boolean;
      }[];
    }
  > = {
    NOVO: {
      buttons: [
        {
          title: "Iniciar",
          status: "Novo",
          color: "#979EA4",
          onAction: () => {
            onTarget(productCode, materialData?.center);
          },
          img: PlusButtonFilter,
          disabled: basicUserInfo.has_crea === false,
        },
      ],
    },
    RECLASSIFICAR: {
      buttons: [
        {
          title: "Iniciar",
          status: "Reclassificar",
          color: "#9e2896",
          onAction: () => {
            onTarget(productCode, materialData?.center);
          },
          img: PlusButtonFilter,
        },
      ],
    },
    EM_CLASSIFICACAO: {
      buttons: [
        {
          title: "Preencher",
          status: "Em Classificação",
          color: "#9DC9FF",
          onAction: () => {
            onTarget(productCode, materialData?.center);
          },
          img: IconAtributo,
          disabled: has_crea || disabledButtonsForEmitter(emitter),
        },
      ],
    },

    FINALIZADO: {
      buttons: [
        {
          title: "Processo Finalizado",
          status: "Processo Finalizado",
          color: "#00884A",
          onAction: () => {},
          disabled: true,
          img: CheckButtonFilter,
        },
      ],
    },
    ENTREGUE_SAP: {
      buttons: [
        {
          title: !isTax ? "Processo Finalizado" : "Entregue SAP",
          status: !isTax ? "Processo Finalizado" : "Entregue SAP",
          color: !isTax ? "#00884A" : "#003E64",
          onAction: () => {},
          disabled: true,
          img: CheckButtonFilter,
        },
      ],
    },
    PENDENTE_VALIDACAO_FISCAL: {
      buttons: [
        {
          title: "Validando",
          status: "Pendente de Validação Fiscal",
          color: "#A1DFDB",
          onAction: () => {},
          disabled: true,
          img: ClockButtonFilter,
        },
      ],
    },
    EM_ANALISE: {
      buttons: [
        {
          title: "Em Análise",
          status: "Em Análise",
          color: "#EEC100",
          onAction: () => {},
          disabled: true,
          img: ClockButtonFilter,
        },
      ],
    },
    RECLASSIFICADO: {
      buttons: [
        {
          title: "Reclassificado",
          status: "Reclassificado",
          color: "#FF9D9D",
          disabled: true,
          img: CheckButtonFilter,
        },
      ],
    },
    SUSPENSO: {
      buttons: [
        {
          title: "Suspenso",
          status: "Suspenso",
          color: "#E8B6E3",
          onAction: () => {},
          disabled: true,
          img: SuspensoButtonFilter,
        },
      ],
    },
    ...(canShowPendingGroup
      ? {
          PENDENTE_GRUPO: {
            buttons: [
              {
                title: "Pendente de Grupo",
                status: "Pendente de Grupo",
                color: "#F97316",
                onAction: () => {},
                disabled: true,
                img: SuspensoButtonFilter,
              },
            ],
          },
        }
      : {}),
  };
  const getStatusInfo = (status: string | undefined) => {
    return (
      statusMap[status ?? ""] || {
        buttons: [],
      }
    );
  };

  const statusActionsMap: Record<
    string,
    {
      aprovar?: boolean;
      comentar?: boolean;
      corrigir?: boolean;
      resetar?: boolean;
    }
  > = {
    EM_CLASSIFICACAO: {
      resetar: true,
    },
    PENDENTE_VALIDACAO_FISCAL: {
      aprovar: true,
      corrigir: true,
      comentar: true,
      resetar: true,
    },
    EM_ANALISE: {
      aprovar: true,
      corrigir: true,
      comentar: false,
      resetar: true,
    },
    RECLASSIFICAR: {
      aprovar: false,
      corrigir: false,
      comentar: false,
      resetar: false,
    },
    FINALIZADO: {
      aprovar: false,
      corrigir: false,
      comentar: false,
    },
    RECLASSIFICADO: {
      aprovar: false,
      corrigir: false,
      comentar: false,
    },
  };
  const getStatusApprover = (status: string | undefined) => {
    return (
      statusActionsMap[status ?? ""] || {
        aprovar: false,
        comentar: false,
        corrigir: false,
        resetar: false,
      }
    );
  };

  useEffect(() => {
    const messages = sessionMaterial?.classificationMessages;

    if (Array.isArray(messages) && messages.length > 0) {
      const lastMessage = messages[messages.length - 1];
      if (lastMessage?.createdAt) {
        setDataCreate(functionDate.formatarData(lastMessage.createdAt));
      }
    }
  }, [sessionMaterial?.classificationMessages]);

  useEffect(() => {
    const isHarmon = sessionMaterial?.hasNcmHarmonizationAlert;
    if (isHarmon) {
      setIsHarmon(isHarmon);
    }
  }, [sessionMaterial?.hasNcmHarmonizationAlert]);

  useEffect(() => {
    const isReasonText = sessionMaterial?.reclassificationReasonText;
    if (isReasonText) {
      setIsReason(isReasonText);
    }
  }, [sessionMaterial?.reclassificationReasonText]);

  const statusInfo = getStatusInfo(materialData?.classificationStatus);
  const statusInfoApprover = getStatusApprover(
    materialData?.classificationStatus,
  );

  let infoAlertComponent = null;

  infoAlertComponent = (
    <InfoAlert
      text={`Atenção! Ao utilizar os dados do favorito, você pode impactar a sugestão
              da NCM e afetar o envio dos atributos à Receita. Verifique se as
              informações estão corretas antes de prosseguir.`}
    />
  );

  const infoList = [
    { label: "NCM", value: materialData?.ncmCode },
    { label: "Master Data", value: sessionMaterial?.ncmMasterData },
    { label: "NALADI", value: sessionMaterial?.naladi },
    { label: "Centro", value: materialData?.center },
    { label: "Favorito", value: materialData?.productSimilarCode },
    {
      label: "Descrição do Produto",
      value: sessionMaterial?.sessionMetadata?.outputFile
        ?.productDescription ? (
        sessionMaterial.sessionMetadata.outputFile.productDescription
      ) : (
        <span className="na-text">N/A</span>
      ),
    },
  ];

  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  return (
    <div className="containerHeading">
      {isExplainabilityLoading && (
        <div
          className="explainabilityLoadingOverlay"
          role="alert"
          aria-live="assertive"
          aria-busy="true"
        >
          <div className="explainabilityLoadingContent">
            <CircularProgress size={52} thickness={4} />
            <span>Gerando relatório explicativo...</span>
          </div>
        </div>
      )}

      {showExplainabilityError && (
        <Notification
          label="Tivemos um problema na geração do relatório. Tente novamente mais tarde."
          backgroundError="#FFB8B8"
          colorError="#000000"
          img={IconAlert}
          setNotification={setShowExplainabilityError}
          top="20px"
          widthError="420px"
        />
      )}

      <div className={simpleHeading ? "upperHome uh-simple" : "upperHome"}>
        <div>
          <span className="titleHome">{titlePage}</span>
        </div>

        {buttonEmissao === "sim" && (
          <div>
            <ButtonGeneric
              img={IconPlus}
              title="Emissão de Novo Laudo"
              colorTitle="#FFFFFF"
              style="buttonHeading"
              onClick={handleNavigation}
              disabled={true}
              data-testid="btn-emissao-laudo"
            />
          </div>
        )}

        {detalsIA && (
          <div>
            <ButtonGeneric
              img={IconHouse}
              title="Salvar e ir à Home"
              colorTitle="#FFFFFF"
              style="buttonHeading"
              onClick={() => {
                toggleModal("isOpen");
                localStorage.removeItem("selectedCenter");
              }}
            />
          </div>
        )}

        {buttonVoltar && (
          <div className="buttonsReturn">
            {statusInfo.buttons.map((btn) => (
              <div key={btn.status}>
                <ButtonGeneric
                  img={btn.img}
                  title={btn.title}
                  colorTitle="#FFFFFF"
                  style="buttonHeading"
                  onClick={() => btn.onAction?.() ?? btn.onClick?.()}
                  disabled={btn.disabled}
                  data-testid={`btn-${btn.title}`}
                />
              </div>
            ))}

            {!buttonAppover && (
              <div>
                <ButtonGeneric
                  img={reloadButtonFilter}
                  title="Resetar"
                  colorTitle="#FFFFFF"
                  background=""
                  style="buttonHeading"
                  disabled={
                    !statusInfoApprover.resetar ||
                    disabledButtonsForEmitter(emitter)
                  }
                  onClick={openModalResetar}
                />
              </div>
            )}

            {!buttonAppover && isEngineer && (
              <div>
                <ButtonGeneric
                  img={transferIcon}
                  title="Assumir Classificação"
                  colorTitle="#FFFFFF"
                  background=""
                  style="buttonHeading"
                  disabled={
                    materialData?.classificationStatus !== "EM_CLASSIFICACAO" ||
                    isCurrentUserEmitter(emitter)
                  }
                  onClick={openModalTransferir}
                  data-testid="btn-transferir"
                />
              </div>
            )}

            <div>
              <ButtonGeneric
                img={IconBack}
                title="Sair"
                colorTitle="#007BC0"
                style="buttonBack"
                onClick={() => {
                  navigate(isTax ? "/home-tax" : "/home-engenheiro");
                  localStorage.removeItem("selectedEmiiter");
                }}
                data-testid="btn-sair"
              />
            </div>
          </div>
        )}

        {buttonAppover && (
          <div className="buttonsReturn">
            <div>
              <ButtonGeneric
                img={approver}
                title="Aprovar"
                colorTitle="#FFFFFF"
                background=""
                style="buttonHeading"
                disabled={!statusInfoApprover.aprovar}
                onClick={openModalAprover}
              />
            </div>
            <div>
              <ButtonGeneric
                img={notificationIcon}
                title="Corrigir"
                colorTitle="#FFFFFF"
                background=""
                style="buttonHeading"
                disabled={
                  !statusInfoApprover.corrigir ||
                  sessionMaterial?.isPassenger === true
                }
                onClick={openModalCorrigir}
              />
            </div>
            <div>
              <ButtonGeneric
                img={reloadButtonFilter}
                title="Resetar"
                colorTitle="#FFFFFF"
                background=""
                style="buttonHeading"
                disabled={!statusInfoApprover.resetar}
                onClick={openModalResetar}
              />
            </div>
            <div>
              <ButtonGeneric
                img={comentar}
                title="Comentar"
                colorTitle="#FFFFFF"
                background=""
                style="buttonHeading"
                disabled={!statusInfoApprover.comentar}
                onClick={openModalComentar}
              />
            </div>

            <div>
              <ButtonGeneric
                img={IconBack}
                title="Sair"
                colorTitle="#007BC0"
                background=""
                style="buttonBack"
                onClick={() => {
                  navigate(isTax ? "/home-tax" : "/home-engenheiro");
                  localStorage.removeItem("selectedEmiiter");
                }}
              />
            </div>
          </div>
        )}

        {buttonDowload && (
          <div className="buttonsReturn">
            <div>
              <ButtonGeneric
                img={Icondownload}
                title="Download PDF"
                colorTitle="#FFFFFF"
                background=""
                style="buttonHeading"
                onClick={() => downloadFile("pdf", getSessionId, true)}
                data-testid="btn-download-pdf"
              />
            </div>
            <div>
              <ButtonGeneric
                img={Icondownload}
                title="downloadFile PDF"
                colorTitle="#FFFFFF"
                background=""
                style="buttonHeading"
                onClick={() => downloadFile("pdf", getSessionId, false)}
              />
            </div>
            <div>
              <ButtonGeneric
                img={Icondownload}
                title="Download Excel"
                colorTitle="#FFFFFF"
                background=""
                style="buttonHeading"
                onClick={() => downloadFile("excel", getSessionId)}
              />
            </div>
          </div>
        )}

        {modalStates.isOpenPDF && (
          <Modal
            titleModal="Aviso"
            className="modalDowload"
            titleDescription="Download concluído"
            bodyModal="Seu download foi finalizado com sucesso!"
            onClose={() => handleCloseModal("isOpenPDF", "pdfDownloaded")}
          />
        )}

        {modalStates.isOpenExcel && (
          <Modal
            titleModal="Aviso"
            className="modalDowload"
            titleDescription="Download concluído"
            bodyModal="Seu download foi finalizado com sucesso!"
            onClose={() => handleCloseModal("isOpenExcel", "excelDownloaded")}
          />
        )}
      </div>

      {titlePage !== "Detalhes do Material" &&
        titlePage !== "Relatório de Solicitações" &&
        titlePage !== "Emissão de Laudo" &&
        isBanner === true &&
        infoAlertComponent}

      {httpStatus === 504 ? (
        <InfoAlert text="Processando... Isso pode levar alguns minutos. Por favor, aguarde." />
      ) : null}

      {simpleHeading && (
        <div>
          <div className="containerStatus cs-simple">
            <div>
              <span className="titleBlock">Part Number: </span>
              <span className="titleBlock" style={{ marginRight: "30px" }}>
                {materialData?.productCode ? (
                  materialData?.productCode
                ) : (
                  <img
                    src={Continuos}
                    alt="sem ncm"
                    style={{ position: "relative", bottom: "3px" }}
                  />
                )}
              </span>
            </div>
            <div>
              <span className="titleBlock">NCM: </span>
              <span className="titleBlock" style={{ marginRight: "30px" }}>
                {materialData?.ncmCode || "N/A"}
              </span>
            </div>


          <div>
              <BallsColor
                titleStatus={statusInfo?.buttons[0]?.status}
                colorStatus={statusInfo?.buttons[0]?.color}
              />
            </div>
          </div>


        </div>
      )}

      {statusProps && (
        <div>
          <div className="containerStatus">
            <div>
              <span className="titleBlock">Part Number: </span>
              <span className="titleBlock" style={{ marginRight: "30px" }}>
                {materialData?.productCode ? (
                  materialData?.productCode
                ) : (
                  <img
                    src={Continuos}
                    alt="sem ncm"
                    style={{ position: "relative", bottom: "3px" }}
                  />
                )}
              </span>
            </div>

            {emitter && (
              <div>
                <span className="titleBlock">Emitente: </span>
                <span className="titleBlock" style={{ marginRight: "30px" }}>
                  {emitter}
                </span>
              </div>
            )}

            <div>
              <BallsColor
                titleStatus={statusInfo?.buttons[0]?.status}
                colorStatus={statusInfo?.buttons[0]?.color}
              />
            </div>
            <div className="iconsContainer">
              {isRead && !isTax && classificationStatuH === "EM_ANALISE" && (
                <img
                  style={{
                    marginLeft: "5px",
                    width: "18px",
                  }}
                  className="iconMessage"
                  src={NotificationIcon}
                  alt="icon-alert"
                />
              )}
              {sessionMaterial?.classificationMessages?.length > 0 && (
                <Tooltip title={"Comentários"}>
                  <button
                    type="button"
                    onClick={() => toggleModal("isComment")}
                    aria-label="Abrir comentários"
                    className="iconCommentBtn"
                  >
                    <img src={IconComment} alt="" aria-hidden="true" />
                  </button>
                </Tooltip>
              )}

              {canDownloadPdf && (
                <div className={showDownloads ? "active" : "no-active"}>
                  <>
                    <Tooltip title={isTax ? "Visualizar PDF" : "Baixar PDF"}>
                      <button
                        type="button"
                        onClick={() =>
                          downloadFile(
                            "pdf",
                            sessionMaterial?.sessionId,
                            !isTax,
                          )
                        }
                        aria-label={isTax ? "Visualizar PDF" : "Baixar PDF"}
                        className="iconButton"
                      >
                        <img src={IconDown} alt="" />
                      </button>
                    </Tooltip>
                  </>
                </div>
              )}
              {canDownloadExplainabilityReport && (
                <div className={showDownloads ? "active" : "no-active"}>
                  <Tooltip title="Relatório Explicativo da Classificação">
                    <button
                      type="button"
                      onClick={() =>
                        openExplainabilityReport(sessionMaterial?.sessionId)
                      }
                      disabled={isExplainabilityLoading}
                      aria-label="Relatório explicativo da classificação"
                      className="iconButton"
                    >
                      <img src={IconReport} alt="" />
                    </button>
                  </Tooltip>
                </div>
              )}
              {sessionMetadataImgs?.length > 0 && (
                <Tooltip title={"Arquivos"}>
                  <button
                    type="button"
                    onClick={() => toggleModal("isArchive")}
                    aria-label="Abrir arquivos"
                    className="iconButton"
                  >
                    <img src={IconArqu} alt="arquivos" />
                  </button>
                </Tooltip>
              )}
            </div>
          </div>

          <div className="containerPartnumber">
            <div className="columnOne">
              {infoList?.slice(0, 3)?.map((item) => {
                const isNCM = item.label === "NCM";
                const isNALADI = item.label === "NALADI" && item.value != null;
                const isPermission = isStatusAllowNaladi({
                  status: classificationStatuH,
                });
                const ishasNcmHarmonizationAlert = isHarmon;

                return (
                  <div key={item.label} className="blockNumber">
                    {isNCM &&
                      isTax &&
                      ishasNcmHarmonizationAlert === true &&
                      sessionMaterial?.isPassenger !== true &&
                      isPermission && (
                        <div className={`${isNCM ? "positionHarm" : ""}`}>
                          <Tooltip
                            title={
                              "NCM sugerida pela IA difere do Master Data. Validar e harmonizar a classificação."
                            }
                          >
                            <img
                              src={IconAlert}
                              alt=""
                              style={{
                                position: "relative",
                                top: -5,
                                cursor: "pointer",
                              }}
                            />
                          </Tooltip>
                          <Tooltip title={"Editar"}>
                            <button
                              type="button"
                              onClick={openModalCorrigir}
                              aria-label="Editar"
                              className="iconButton"
                              style={{
                                position: "relative",
                                width: 20,
                                height: 16,
                              }}
                            >
                              <img
                                src={IconEdit}
                                alt=""
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  cursor: "pointer",
                                }}
                              />
                            </button>
                          </Tooltip>
                        </div>
                      )}

                    {isNALADI && isTax && isPermission && (
                      <div className={`${isNALADI ? "positionHarm" : ""}`}>
                        <Tooltip title={"Editar"}>
                          <button
                            type="button"
                            onClick={openModalNaladi}
                            aria-label="Editar"
                            className="iconButton"
                            style={{
                              position: "relative",
                              width: 20,
                              height: 16,
                            }}
                          >
                            <img
                              src={IconEdit}
                              alt=""
                              style={{
                                position: "relative",
                                cursor: "pointer",
                                width: 20,
                                height: 16,
                              }}
                            />
                          </button>
                        </Tooltip>
                      </div>
                    )}

                    <img
                      src={IconParams}
                      alt=""
                      style={{
                        position: "relative",
                        top: "3px",
                        marginRight: 15,
                      }}
                    />

                    <span className="titleBlock">{item.label}: </span>
                    <span>{item.value || "N/A"}</span>
                  </div>
                );
              })}

              {isReason && isReason.trim() !== "" && (
                <div className="blockNumber reason">
                  <img
                    src={IconParams}
                    alt=""
                    style={{
                      position: "relative",
                      top: "3px",
                      marginRight: 15,
                    }}
                  />
                  <span className="titleBlock">
                    Justificativa da reclassificação:{" "}
                  </span>
                  <span>{isReason}</span>
                </div>
              )}
            </div>

            <div className="columnTwo">
              {infoList?.slice(3)?.map((item) => {
                const isDescricao = item.label === "Descrição do Produto";
                const displayValue = item.value ? item.value : "N/A";

                return (
                  <div
                    key={item.label}
                    className={`blockNumber ${isDescricao ? "positionT" : ""}`}
                  >
                    <img
                      src={IconParams}
                      alt=""
                      style={{
                        position: "relative",
                        top: "3px",
                        marginRight: 15,
                      }}
                    />
                    <span className="titleBlock">{item.label}: </span>

                    {isDescricao ? (
                      <>
                        <DescriptionCell
                          value={item.value}
                          onViewMore={(displayValue) => {
                            setIsModalOpen(true);
                            setDescription(displayValue);
                          }}
                        />
                        {isModalOpen && (
                          <ModalLog
                            className="ModalViewDescriptions modalContent descriptionModal"
                            titleModalLog={"Descrição"}
                            subTitleModalLog={displayValue || ""}
                            textModalLog={""}
                            imgIcon={iconabort}
                            onClose={() => setIsModalOpen(false)}
                          />
                        )}
                      </>
                    ) : (
                      <span>{displayValue}</span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      {blockText && (
        <div className="detalsLaudo">
          <span>{text1}</span>
          <span>{text2}</span>
          <span>{text3}</span>
        </div>
      )}
      {filtros && (
        <div>
          <div style={{ height: "35px", marginTop: "10px" }}>
            <span>Filtros</span>
          </div>

          <div>
            <Filters
              setMaterialPartNumber={setMaterialPartNumber}
              materialPartNumber={materialPartNumber}
              setMaterialPartDesc={setMaterialPartDesc}
              emitentePartNumber={emitentePartNumber}
              setEmitentePartDesc={setEmitentePartDesc}
              centerFilter={centerFilter}
              setCenterFilter={setCenterFilter}
              materialPartDesc={materialPartDesc}
              setStartDate={setStartDate}
              startDate={startDate}
              endDate={endDate}
              setEndDate={setEndDate}
              classificationQuizStartDate={classificationQuizStartDate}
              setClassificationQuizStartDate={setClassificationQuizStartDate}
              classificationQuizFinishDate={classificationQuizFinishDate}
              setClassificationQuizFinishDate={setClassificationQuizFinishDate}
              classificationApprovalStartDate={classificationApprovalStartDate}
              setClassificationApprovalStartDate={setClassificationApprovalStartDate}
              classificationApprovalEndDate={classificationApprovalEndDate}
              setClassificationApprovalEndDate={setClassificationApprovalEndDate}
              selectedOptionsStatus={selectedOptionsStatus}
              setSelectedOptionsStatus={setSelectedOptionsStatus}
              selectedOptionsCenter={selectedOptionsCenter}
              setSelectedOptionsCenter={setSelectedOptionsCenter}
              selectedOptionsFlag={selectedOptionsFlag}
              setSelectedOptionsFlag={setSelectedOptionsFlag}
              selectedOptionsHarmon={selectedOptionsHarmon}
              setSelectedOptionsHarmon={setSelectedOptionsHarmon}
              handleFilter={handleFilter}
              setPage={setPage}
              setPageSize={setPageSize}
              setFilter={setFilter}
            />
          </div>
        </div>
      )}

      {modalStates.isOpen && (
        <Modal
          titleDescriptions="Você deseja salvar e voltar à Home?"
          titleModal="Aviso"
          bodyModal={
            <span style={{ marginTop: "-10px" }}>
              Suas respostas até o momento serão salvas e você será
              redirecionado para a página inicial.
            </span>
          }
          onClose={() => toggleModal("isOpen")}
          onConfirm={() => backButton()}
          buttonOne="Sim"
          buttonTwo="Não"
          className="buttonEditModal"
        />
      )}

      <MuiModal open={isViewerOpen} onClose={() => setIsViewerOpen(false)}>
        <div
          style={{
            marginLeft: 110,
            marginTop: 40,
            width: "90%",
            height: "90%",
            position: "relative",
          }}
        >
          <Tooltip title={"Fechar modal"}>
            <button
              type="button"
              onClick={() => setIsViewerOpen(false)}
              aria-label="Fechar modal"
              className="iconButton"
              style={{
                position: "absolute",
                bottom: 3,
                width: 23,
                right: "154px",
                top: "18px",
              }}
            >
              <img
                src={close}
                alt=""
                style={{
                  width: "100%",
                  cursor: "pointer",
                }}
              />
            </button>
          </Tooltip>
          <iframe
            src={pdfUrl ?? undefined}
            width="100%"
            height="100%"
            title="Visualização do PDF"
          />
        </div>
      </MuiModal>

      {modalStates.isComment && (
        <Modal
          titleModal="Comentários"
          onClose={() => toggleModal("isComment")}
          className="buttonEditModal"
        >
          <div className="containerMaterial" style={{ marginTop: "17px" }}>
            <div className="column-1">
              <div
                style={{
                  display: "flex",
                  position: "absolute",
                  top: 18,
                  left: 120,
                }}
              >
                {isRead && !isTax && (
                  <img
                    style={{
                      marginLeft: "5px",
                      width: "18px",
                      height: "18px",
                    }}
                    src={NotificationIcon}
                    alt="icon-alert"
                  />
                )}
              </div>

              {sessionMaterial?.classificationMessages?.length > 0 ? (
                <div className="bodyComments">
                  <div>
                    <span>
                      {sessionMaterial?.classificationMessages[0]?.userEmail}
                    </span>

                    <div className="textMessage">
                      <span>
                        {sessionMaterial?.classificationMessages[0]?.message}
                      </span>
                    </div>
                    <div className="textData">
                      <span>{dataCreate}</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="bodyComments">
                  <span className="semComments">Sem comentários.</span>
                </div>
              )}
            </div>
          </div>
        </Modal>
      )}
      {modalStates.isArchive && (
        <>
          <Modal
            titleModal="Arquivos"
            onClose={() => toggleModal("isArchive")}
            className="buttonEditModal filesModal"
          >
            <div className="containerDownloadImages">
              <div className="bodyComments">
                {Array.isArray(sessionMetadataImgs) &&
                sessionMetadataImgs.length > 0 ? (
                  <ul style={{ margin: 0, padding: 0, width: "100%" }}>
                    {sessionMetadataImgs.map((img, index) => (
                      <li
                        key={img.fileName}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                          }}
                        >
                          <div style={{ display: "flex", marginRight: 20 }}>
                            <img
                              style={{ marginRight: 10, height: 20 }}
                              src={IconImg}
                              alt="Icon imagem"
                            />
                            <span>{truncateText(img.fileName, 25)}</span>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <a
                              href={img.downloadUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                color: "#007BC0",
                                display: "flex",
                              }}
                            >
                              <img
                                style={{ marginRight: 10, height: 20 }}
                                src={IconD}
                                alt=""
                              />
                              <span style={{ fontWeight: 400 }}>Download</span>
                            </a>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span className="semComments">Sem arquivos.</span>
                )}
              </div>
            </div>
          </Modal>
        </>
      )}
    </div>
  );
};

export default Heading;
